import React from 'react'
import { FaThumbtack } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/pin.less'

type PinControlProps = {
  activeNodes: string[]
  pinned: {
    nodes: Record<string, unknown>
  }
  togglePinActive: () => void
  isCreating: boolean
  isEditing: boolean
  control: string
}

const PinControl = ({ activeNodes, pinned, togglePinActive, isCreating, isEditing, control }: PinControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (isCreating || isEditing) {
      return
    }
    togglePinActive()
  }

  let unpin = false
  for (const nId of activeNodes) {
    if (pinned.nodes[nId]) {
      unpin = true
    }
  }
  const title = unpin ? 'Unpin' : 'Pin'
  return (
    <div className={cn('control', 'pin')} data-graph-type="control" title={`${title} ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing, unpin })} onClick={handleClick}>
        <FaThumbtack aria-hidden />
        <span className="sr-only">{unpin ? 'Unpin' : 'Pin'}</span>
      </a>
    </div>
  )
}

export default PinControl
